import { render, staticRenderFns } from "./approval_count.vue.js?vue&type=template&id=72f0c31e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approval_count.vue?vue&type=template&id=72f0c31e"
import script from "./approval_count.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approval_count.vue?vue&type=script&lang=js"
export * from "./approval_count.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./approval_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports